import { Style, StyleWrapper } from "@design-system/style-sheet"
import { Theme, GrouponTheme, LivingsocialTheme } from "@design-system/themes"
import { Themes } from "./themes"
import { NamedStyle } from "../types"

const defaultTheme = GrouponTheme
const livingsocialTheme = LivingsocialTheme
const darkTheme = GrouponTheme

declare global {
  const I18n: {
    brandId?: string | undefined
    themeKey?: string | undefined
  }
}

function getThemeByBrand(
  brand: string | undefined,
  themeKey: string | undefined,
): Theme {
  if (brand === "livingsocial") {
    return livingsocialTheme
  }

  if (themeKey === "dark") {
    return darkTheme
  }

  return defaultTheme
}

function getThemeByI18n() {
  let theme = defaultTheme
  if (typeof I18n !== "undefined") {
    theme = getThemeByBrand(I18n.brandId, I18n.themeKey)
  }
  return theme
}

const theme = getThemeByI18n()
export const Styles = new Themes(theme)

export const setTheme = (
  brand: string | undefined,
  themeKey: string | undefined = undefined,
) => {
  const theme = getThemeByBrand(brand, themeKey)
  Styles.setTheme(theme)
}

export function createStyles<P extends NamedStyle, T = { [name: string]: P }>(
  style: (theme: Theme) => T,
): { [name in keyof T]: StyleWrapper<T[name]> }
export function createStyles<P extends NamedStyle, T = { [name: string]: P }>(
  style: T,
): { [name in keyof T]: StyleWrapper<T[name]> }

export function createStyles<P extends NamedStyle, T = { [name: string]: P }>(
  style: ((theme: Theme) => T) | T,
) {
  return Styles.create(style)
}

export function createCSS<T extends { [name: string]: Style }>(
  style: (theme: Theme) => T,
): { [name in keyof T]: string }
export function createCSS<T extends { [name: string]: Style }>(
  style: T,
): { [name in keyof T]: string }

export function createCSS<T extends { [name: string]: Style }>(
  style: ((theme: Theme) => T) | T,
) {
  return Styles.createCSS(style)
}
